/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import { Spacer } from "@cd2/components"

import { Logo } from "./Logo"
import { useTheme } from "@cd2/theme"
import { P } from "@cd2/text/build/es6"
import { useEffect } from "react"

export function ErrorSplashScreen() {
  const { themeColor } = useTheme()

  useEffect(() => {
    window.localStorage.clear()
  }, [])

  return (
    <div
      css={css`
        position: fixed;
        z-index: 999999;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background: ${themeColor("primary")};
        padding-top: calc(25vh);
      `}
    >
      <Logo height={100} vertical />
      <Spacer size={64} />
      <P align="center" color="white">
        An error has occurred launching the application. <br /> Please refresh and try again.
      </P>
    </div>
  )
}
